import { render, staticRenderFns } from "./Seo5.vue?vue&type=template&id=c16f9cb6&scoped=true&"
import script from "./Seo5.vue?vue&type=script&lang=js&"
export * from "./Seo5.vue?vue&type=script&lang=js&"
import style0 from "./Seo5.vue?vue&type=style&index=0&id=c16f9cb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16f9cb6",
  null
  
)

export default component.exports